var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardSlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "280px",
    height: "203px",
    viewBox: "0 0 280 203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logomarca e-invest blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 279.643939 0 279.643939 202.9996 0 202.9996"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logomarca-e-invest-blue",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3587,154.343 L278.6297,134.186 C280.9667,129.598 279.1257,125.845 274.5387,125.845 L132.0467,125.845 C127.4587,125.845 121.7927,129.598 119.4557,134.186 L109.1847,154.343 C106.8477,158.931 108.6887,162.684 113.2757,162.684 L255.7677,162.684 C260.3557,162.684 266.0217,158.931 268.3587,154.343 M221.0927,108.468 L231.0097,89.005 C233.3467,84.418 231.5057,80.664 226.9187,80.664 L131.6927,80.664 C127.1047,80.664 121.4387,84.418 119.1017,89.005 L109.1847,108.468 C106.8477,113.055 108.6887,116.809 113.2757,116.809 L208.5017,116.809 C213.0897,116.809 218.7557,113.055 221.0927,108.468 M268.3587,63.287 L278.6297,43.13 C280.9667,38.542 279.1257,34.789 274.5387,34.789 L132.0467,34.789 C127.4587,34.789 121.7927,38.542 119.4557,43.13 L109.1847,63.287 C106.8477,67.875 108.6887,71.628 113.2757,71.628 L255.7677,71.628 C260.3557,71.628 266.0217,67.875 268.3587,63.287 M168.5837,109.491 C167.3287,121.257 164.2847,131.956 159.7867,141.623 C150.7297,161.082 136.7027,173.228 130.5277,178.535 C124.5027,183.714 118.9797,187.474 114.9037,190.014 C110.1447,192.276 105.3857,194.539 100.6267,196.802 C95.9517,198.977 91.0587,200.825 86.0577,202.565 L85.9487,202.565 L84.5347,203 C82.4687,202.456 80.5117,201.804 78.5547,201.042 C38.6507,186.146 5.5967,156.137 0.5947,109.6 C-1.5793,88.941 2.7697,37.62 4.6177,17.614 C4.8357,12.939 7.9887,8.916 12.5557,7.828 C36.2587,2.827 60.3967,0.217 84.6437,0 C108.8907,0.108 133.0287,2.827 156.7317,7.828 C161.1897,8.916 164.4517,12.939 164.6697,17.614 C166.5177,37.512 170.8667,88.941 168.5837,109.491",
    id: "Fill-1",
    fill: "#1C3F8B",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardSlogo);
export default __webpack_public_path__ + "static/media/STANDARD_slogo.c3456118d2d9629110ca1b4b7af7590c.svg";
export { ForwardRef as ReactComponent };